/**
 * 2007-2016 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Open Software License (OSL 3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * http://opensource.org/licenses/osl-3.0.php
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2016 PrestaShop SA
 * @license   http://opensource.org/licenses/osl-3.0.php Open Software License (OSL 3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import $ from 'jquery';

import PhotoSwipe from './lib/photoswipe.min';
import PhotoSwipeUI_Default from './lib/photoswipe-ui-default.min';

$(document).ready(function () {
  createProductSpin();
  createInputFile();
  coverImage();
  imageScrollBox();

  prestashop.on('updatedProduct', function (event) {
    createInputFile();
    coverImage();
    if (event && event.product_minimal_quantity) {
      const minimalProductQuantity = parseInt(event.product_minimal_quantity, 10);
      const quantityInputSelector = '#quantity_wanted';
      let quantityInput = $(quantityInputSelector);

      // @see http://www.virtuosoft.eu/code/bootstrap-touchspin/ about Bootstrap TouchSpin
      quantityInput.trigger('touchspin.updatesettings', {min: minimalProductQuantity});
    }
    imageScrollBox();
    $($('.tabs .nav-link.active').attr('href')).addClass('active').removeClass('fade');
    $('.js-product-images-modal').replaceWith(event.product_images_modal);
  });

  function coverImage() {
    // photoswipe product page
    $('#product .images-container .product-images').each( function() {
      var $pic     = $(this),
        getItems = function() {
          var items = [];
          $pic.find('.thumb').each(function() {
            var $href   = $(this).data('image-large-src'),
              $size   = $(this).data('size').split('x'),
              $width  = $size[0],
              $height = $size[1];

            var item = {
              src : $href,
              w   : $width,
              h   : $height
            }

            items.push(item);
          });
          return items;
        }

      var items = getItems();

      var $pswp = $('.pswp')[0];
      $pic.on('click', '.thumb-container', function(event) {
        event.preventDefault();
         
        var $index = $(this).index();
        var options = {
            index: $index,
            bgOpacity: 0.7,
            showHideOpacity: true
        }
         
        // Initialize PhotoSwipe
        var lightBox = new PhotoSwipe($pswp, PhotoSwipeUI_Default, items, options);
        lightBox.init();
      });
    });


    $('.js-qv-product-cover').on(
      'click',
      (event) => {
        console.log('click');
        $( '.thumb-container .selected' ).click();
      }
    );
    $('.thumb-container').on('mouseover', (event) => {
      $('.thumb-container').removeClass('selected');
      $(event.currentTarget).addClass('selected');
      $('.js-qv-product-cover').attr('src', $(event.target).children('.thumb').data('image-large-src'));
    });
  }

  function imageScrollBox()
  {
    if ($('#main .js-qv-product-images li').length > 2) {
      $('#main .js-qv-product-images').addClass('scroll');
      $('#product #main .js-qv-product-images').bxSlider({
        minSlides: 1,
        maxSlides: 10,
        slideWidth: 90,
        slideMargin: 0,
        pager: false,
        nextText: '',
        prevText: '',
        moveSlides:1,
        infiniteLoop:false,
        hideControlOnEnd: true
      });
    } else {
      $('#main .js-qv-product-images').removeClass('scroll');
    }
  }

  function createInputFile()
  {
    $('.js-file-input').on('change',(event)=>{
      $('.js-file-name').text($(event.currentTarget).val());
    });
  }

  function createProductSpin()
  {
    let quantityInput = $('#quantity_wanted');
    quantityInput.TouchSpin({
      min: parseInt(quantityInput.attr('min'), 10),
      max: 1000000
    });

    quantityInput.on('change', function (event) {
      let $productRefresh = $('.product-refresh');
      $(event.currentTarget).trigger('touchspin.stopspin');
      $productRefresh.trigger('click', {eventType: 'updatedProductQuantity'});
      event.preventDefault();

      return false;
    });
  }
});



// WEBPACK FOOTER //
// ./js/product.js